import { slicedToArray as _slicedToArray, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useCallback, useEffect } from 'react';

var _excluded = ["children"];
function useDotButton(emblaApi) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollSnaps = _useState4[0],
    setScrollSnaps = _useState4[1];
  var onDotButtonClick = useCallback(function (index) {
    if (!emblaApi) return;
    emblaApi.scrollTo(index);
  }, [emblaApi]);
  var onInit = useCallback(function (api) {
    setScrollSnaps(api.scrollSnapList());
  }, []);
  var onSelect = useCallback(function (api) {
    setSelectedIndex(api.selectedScrollSnap());
  }, []);
  useEffect(function () {
    if (!emblaApi) return;
    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect);
  }, [emblaApi, onInit, onSelect]);
  return {
    selectedIndex: selectedIndex,
    scrollSnaps: scrollSnaps,
    onDotButtonClick: onDotButtonClick
  };
}
function DotButton(_ref) {
  var children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("button", _extends({
    type: "button"
  }, restProps), children);
}

export { DotButton, useDotButton };
//# sourceMappingURL=EmblaCarouselDotButton.js.map
